import update from '../../utilities/update';
export const success = (state, message) => {
    return update(state, {
        loading: false,
        error: null,
        message
    })
}

